import Icon from "../Icon/Icon"
import "./GetApp.scss";

const GetAppBanner = ({ onClose, onGetApp }) => {
    return (
        <div className="bigContainer">
            <div
                className="get-app-banner d-flex f-row aic jcsb"
            >
                <div className="d-flex f-row aic"><div className="app-banner-logo-container d-flex aic jcc">
                    <Icon alias="logo_get_app" width={20} height={20} color="#fff" />
                </div>
                    <p className="fs-regular fw-bold fg-white pl-12">Get HYK app </p>
                </div>
                <div className="d-flex f-row aic"> <button className="button-get-app mr-12"
                    style={{ height: '32px', width: '96px' }}
                    onClick={onGetApp}
                >
                    <span>Get App</span>
                </button>
                    <Icon alias="close_get_app" width={20} height={20} color="#0A0F1E" onClick={onClose} />
                </div>
            </div>
            </div>
    )
}
export default GetAppBanner